import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import QRCodeGenerator from './pages/QRCodeGenerator';
import BarcodeGenerator from './pages/BarcodeGenerator';
import './styles/App.css';

// Navigation component
const Navigation = () => {
  const location = useLocation();
  
  return (
    <nav className="nav-bar">
      <div className="nav-brand">
        <span className="brand-icon">📱</span>
        <span className="brand-name">qr-bar-generator</span>
      </div>
      <ul className="nav-links">
        <li>
          <Link 
            to="/" 
            className={location.pathname === '/' ? 'active' : ''}
          >
            📌 QR Codes
          </Link>
        </li>
        <li>
          <Link 
            to="/barcodes" 
            className={location.pathname === '/barcodes' ? 'active' : ''}
          >
            📊 Barcodes
          </Link>
        </li>
      </ul>
    </nav>
  );
};

function App() {
  return (
    <Router>
      <div className="app">
        <Navigation />
        <main className="main-content">
          <Routes>
            <Route path="/" element={<QRCodeGenerator />} />
            <Route path="/barcodes" element={<BarcodeGenerator />} />
          </Routes>
        </main>
        <footer className="app-footer">
          <div className="footer-content">
            <span>🔒 API: {process.env.VITE_API_URL || 'QR and Barcode API'}</span>
            <span>🌍 Environment: {process.env.VITE_ENV || 'production'}</span>
            <span>⚡ Developed by OpenbizIT</span>
          </div>
        </footer>
      </div>
    </Router>
  );
}

export default App;